module.exports = __webpack_public_path__ + "static/media/floaters-mini.2c404ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floaters-mini.png
// module id = 468
// module chunks = 0